import * as React from 'react';
import { findVoiceById, getDefaultVoiceForLanguage } from './StaticVoiceData';
import { LanguageCode } from '@visikon/core-models/languageTypes';

interface UsePreferredVoiceProps {
  selectedLanguage: LanguageCode;
  selectedVoiceId?: string;
}

export const usePreferredVoice = ({ selectedLanguage, selectedVoiceId }: UsePreferredVoiceProps) => {
  const { voiceId, voiceLabel } = React.useMemo(() => {
    if (selectedVoiceId) {
      const existingVoice = findVoiceById(selectedVoiceId);
      if (existingVoice) {
        return { voiceId: existingVoice.voice, voiceLabel: existingVoice.name };
      }
    }

    const fallbackVoice = getDefaultVoiceForLanguage(selectedLanguage);
    if (fallbackVoice) {
      return { voiceId: fallbackVoice.voice, voiceLabel: fallbackVoice.name };
    }

    return { voiceId: '', voiceLabel: '' };
  }, [selectedLanguage, selectedVoiceId]);

  return { voiceId, voiceLabel };
};
